import { useSelector } from 'react-redux'

import { Box, Grid } from '@chakra-ui/react'

import { Card, SettingsRow } from '@/components/ui'
import { selectEmail, selectFullName } from '@/redux/me/meSlice'

export const AccountInformation = () => {
  const fullName = useSelector(selectFullName)
  const email = useSelector(selectEmail)

  // Will be added back in https://hivewatch.atlassian.net/browse/ENG-9274
  // const {
  //   isOpen: isChangeEmailOpen,
  //   onOpen: onChangeEmailOpen,
  //   onClose: onChangeEmailClose,
  // } = useDisclosure()
  // const {
  //   isOpen: isChangePasswordOpen,
  //   onOpen: onChangePasswordOpen,
  //   onClose: onChangePasswordClose,
  // } = useDisclosure()

  return (
    <>
      <Card
        _hover={{
          boxShadow: '0px 2px 5px 6px rgba(0, 0, 0, 0.15)',
        }}
        p='0'
        transition='ease-in-out'
        transitionDuration='300ms'
        transitionProperty='all'
      >
        <Box
          fontSize='20px'
          fontWeight='extrabold'
          letterSpacing='-0.6px'
          p='4'
        >
          Account Information
        </Box>
        <Box
          bgColor='#F0F5FD'
          borderBottom='1px solid #eaedf3'
          borderTop='1px solid #eaedf3'
          p='4'
        >
          <Grid gap='6' gridTemplateColumns='auto 1fr' my='4' w='full'>
            <SettingsRow
              dataTestId='settingsPage_accountInformation_name'
              label='Name'
              value={fullName}
            />
            <SettingsRow
              dataTestId='settingsPage_accountInformation_email'
              label='Email'
              value={email}
            />
          </Grid>
        </Box>
        {/* Doesn't work, should be hidden. Will be added back in https://hivewatch.atlassian.net/browse/ENG-9276 */}
        {/* <Box p='4'>
          <Box
            fontSize='20px'
            fontWeight='extrabold'
            letterSpacing='-0.6px'
            mb='5'
          >
            Password
          </Box>
          <Button
            onClick={onChangePasswordOpen}
            data-testid='settingsPage_accountInformation_changePasswordButton'
          >
            Change Password
          </Button>
        </Box> */}
      </Card>
      {/* <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        onClose={onChangePasswordClose}
      />
      <ChangeEmailModal
        isOpen={isChangeEmailOpen}
        onClose={onChangeEmailClose}
      /> */}
    </>
  )
}
